"use client";

import { ComponentProps } from "react";
import { Builder, BuilderComponent, useIsPreviewing } from "@builder.io/react";
import { builder } from "@builder.io/sdk";
import "builder-registry";
import { NotFoundPage } from "./not-found-page";

type BuilderPageProps = ComponentProps<typeof BuilderComponent>;

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);

export function RenderBuilderContent(props: BuilderPageProps) {
  const isPreviewing = useIsPreviewing();

  if (props.content || isPreviewing || Builder.isEditing) {
    return <BuilderComponent {...props} />;
  }

  return <NotFoundPage />;
}
